<div id="{{id}}" class="modal modal-lg fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
    
            <div class="comparison-modal-header">
                <h1 class="title w-100" translate>Find Your Perfect Program</h1>
                <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
        
            <div class="modal-body">
                <app-comparison-stepper></app-comparison-stepper>
            </div>
        </div>
    </div>
</div>

